import React from 'react';
import { Box, Typography } from '@mui/material';

interface NotificationBubbleProps {
  show: boolean;
  count: number;
  onDismiss?: () => void; // Make optional since we don't need dismiss functionality
}

const NotificationBubble: React.FC<NotificationBubbleProps> = ({ show, count }) => {
  console.log('NotificationBubble render:', { show, count });

  if (!show || count === 0) {
    console.log('NotificationBubble: not showing (show:', show, 'count:', count, ')');
    return null;
  }

  console.log('NotificationBubble: rendering bubble');

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '4px',
        right: '4px',
        backgroundColor: '#1976d2', // Blue background like Actions sidebar
        color: 'white',
        borderRadius: '50%', // Circular badge
        minWidth: '18px',
        height: '18px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.7rem',
        fontWeight: 'bold',
        zIndex: 1000,
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontSize: '0.65rem',
          fontWeight: 'bold',
          color: 'white',
          lineHeight: 1,
        }}
      >
        {count > 99 ? '99+' : count}
      </Typography>
    </Box>
  );
};

export default NotificationBubble;
